<template>
  <div class="t-p-8">
    <h2 class="t-font-normal">In Development</h2>
    <div class="t-grid t-grid-cols-1 md:t-grid-cols-2 lg:t-grid-cols-4 t-w-full t-gap-8 t-mt-4">
      <div class="t-rounded-md t-bg-grey-20 t-p-4 md:t-col-span-2">
        <h3 class="t-mb-2 t-font-semibold">General dev data</h3>
        <div class="t-mb-2">
          <label for="projectId" class="t-mb-2">
            Project Id
            <a
              class="t-ml-2"
              :href="`${baseUrl}/#projects/${projectId}`"
              rel="noopener"
              target="_blank"
            >
              Link to project
            </a>
          </label>
          <TTextField
            id="projectId"
            v-model="projectId"
            background-color="var(--token-ui-bg)"
            class="t-text-default"
            dense
            flat
            solo
            hide-details="auto"
            :outlined="v$.projectId.$error"
            :error="v$.projectId.$error"
          />
        </div>
        <div class="t-mb-2">
          <label for="projectType">Project type</label>
          <TTextField
            id="projectType"
            v-model="projectType"
            background-color="var(--token-ui-bg)"
            class="t-text-default"
            dense
            flat
            solo
            hide-details="auto"
            :outlined="v$.projectType.$error"
            :error="v$.projectType.$error"
          />
        </div>
        <div class="t-mb-2">
          <label for="budgetId"> Budget Id </label>
          <TTextField
            id="budgetId"
            v-model="budgetId"
            background-color="var(--token-ui-bg)"
            class="t-text-default"
            dense
            flat
            solo
            hide-details="auto"
            :outlined="v$.budgetId.$error"
            :error="v$.budgetId.$error"
          />
        </div>
        <h3 class="t-mb-2 t-mt-4 t-font-semibold">Automations dev data</h3>
        <div>
          <label for="featuredTemplates">Featured templates</label>
          <span class="t-text-xs"> (example: <code>move_to_board_column</code>)</span>
          <TTextField
            id="featuredTemplates"
            v-model="featuredTemplates"
            background-color="var(--token-ui-bg)"
            class="t-text-default"
            dense
            flat
            solo
            hide-details="auto"
            :outlined="v$.featuredTemplates.$error"
            :error="v$.featuredTemplates.$error"
          />
        </div>
        <div>
          <label for="defaultTrigger">Default trigger</label>
          <span class="t-text-xs"> (example: <code>workflow_stage_changed</code>)</span>
          <TTextField
            id="defaultTrigger"
            v-model="defaultTrigger"
            background-color="var(--token-ui-bg)"
            class="t-text-default"
            dense
            flat
            solo
            hide-details="auto"
            :outlined="v$.defaultTrigger.$error"
            :error="v$.defaultTrigger.$error"
          />
        </div>
        <div>
          <label for="automationId">Automation id</label>
          <TTextField
            id="automationId"
            v-model="automationId"
            background-color="var(--token-ui-bg)"
            class="t-text-default"
            dense
            flat
            solo
            hide-details="auto"
            :outlined="v$.automationId.$error"
            :error="v$.automationId.$error"
          />
        </div>
        <div>
          <label for="boardColumnId">Board column id</label>
          <TTextField
            id="boardColumnId"
            v-model="boardColumnId"
            background-color="var(--token-ui-bg)"
            class="t-text-default"
            dense
            flat
            solo
            hide-details="auto"
            :outlined="v$.boardColumnId.$error"
            :error="v$.boardColumnId.$error"
          />
        </div>
        <div>
          <label for="workflowId">Workflow id</label>
          <TTextField
            id="workflowId"
            v-model="workflowId"
            background-color="var(--token-ui-bg)"
            class="t-text-default"
            dense
            flat
            solo
            hide-details="auto"
            :outlined="v$.workflowId.$error"
            :error="v$.workflowId.$error"
          />
        </div>
        <div>
          <label for="workflowStageId">Workflow stage id</label>
          <TTextField
            id="workflowStageId"
            v-model="workflowStageId"
            background-color="var(--token-ui-bg)"
            class="t-text-default"
            dense
            flat
            solo
            hide-details="auto"
            :outlined="v$.workflowStageId.$error"
            :error="v$.workflowStageId.$error"
          />
        </div>
        <div>
          <label for="categoryToShow">Category to show</label>
          <span class="t-text-xs"> (example: <code>Board column</code>)</span>
          <TTextField
            id="categoryToShow"
            v-model="categoryToShow"
            background-color="var(--token-ui-bg)"
            class="t-text-default"
            dense
            flat
            solo
            hide-details="auto"
            :outlined="v$.categoryToShow.$error"
            :error="v$.categoryToShow.$error"
          />
        </div>
        <div>
          <label for="initialView">Initial view</label>
          <span class="t-text-xs"> (example: <code>templates</code>)</span>
          <TTextField
            id="initialView"
            v-model="initialView"
            background-color="var(--token-ui-bg)"
            class="t-text-default"
            dense
            flat
            solo
            hide-details="auto"
            :outlined="v$.initialView.$error"
            :error="v$.initialView.$error"
          />
        </div>
      </div>
      <div class="t-rounded-md t-bg-grey-20 t-p-4">
        <h3 class="t-mb-2 t-font-semibold">Pages</h3>
        <ul class="t-list-none t-divide-y">
          <li>
            <router-link :to="{ name: 'people-people' }">{{ $t('People') }}</router-link>
          </li>
          <li>
            <router-link :to="`/projects/${projectId}/people/people`">Project People</router-link>
          </li>
          <li>
            <router-link :to="`/projects/${projectId}/notebooks/list`">
              Project Notebooks
            </router-link>
          </li>
          <li>
            <router-link :to="`/projects/${projectId}/forms`">Project Forms</router-link>
          </li>
        </ul>
      </div>
      <div class="t-rounded-md t-bg-grey-20 t-p-4">
        <h3 class="t-mb-2 t-font-semibold">Modals</h3>
        <ul class="t-list-none t-divide-y">
          <li>
            <a href="#" @click.prevent="openModal('ProjectBillableRatesModal', { projectId })">
              ProjectBillableRatesModal
            </a>
          </li>
          <li>
            <a
              href="#"
              @click.prevent="
                openModal('BulkEditUserBillableRatesModal', {
                  users: [
                    {
                      id: 1,
                      firstName: 'Big',
                      lastName: 'Boss',
                      avatarUrl: 'https://icotar.com/avatar/boss.svg',
                    },
                    {
                      id: 2,
                      firstName: 'Micro',
                      lastName: 'Manager',
                      avatarUrl: 'https://icotar.com/avatar/manager.svg',
                    },
                  ],
                })
              "
            >
              BulkEditUserBillableRatesModal
            </a>
          </li>
          <li>
            <a
              href="#"
              @click.prevent="
                openModal('ProjectBudgetModal', {
                  projectId,
                  successCallback: onCreateBudgetSuccessCallback,
                })
              "
            >
              ProjectBudgetModal - Create
            </a>
          </li>
          <li v-if="budgetId">
            <a
              href="#"
              @click.prevent="
                openModal('ProjectBudgetModal', {
                  projectId,
                  budgetId,
                })
              "
            >
              ProjectBudgetModal - Edit (Id: {{ budgetId }})
            </a>
          </li>
          <li v-if="budgetId">
            <a
              href="#"
              @click.prevent="
                openModal('ProjectBudgetConflictModal', {
                  code: 'PBC2',
                  minDate,
                  maxDate,
                })
              "
            >
              ProjectBudgetConflictModal
            </a>
          </li>
          <li>
            <a href="#" @click.prevent="openConfirmDialog">ConfirmDialog</a>
          </li>
          <li>
            <a
              href="#"
              @click.prevent="
                openModal('AutomationsModal', {
                  projectId: Number(projectId),
                  projectType,
                  automationId,
                  boardColumnId: Number(boardColumnId),
                  workflowId: Number(workflowId),
                  workflowStageId: Number(workflowStageId),
                  categoryToShow,
                  initialView,
                  ...(featuredTemplates && { featuredTemplates }),
                  ...(defaultTrigger && { defaultTrigger }),
                })
              "
            >
              Automations
            </a>
          </li>
          <li>
            <a
              href="#"
              @click.prevent="
                openModal('AutomationCardProjectListModal', {
                  projects: [
                    'Billing',
                    'common-frontend-builder',
                    'Content Team',
                    'Corporate Marketing',
                    'Demand Generation',
                    'Desk Q2 2021',
                    'dev-env',
                    'Billing',
                    'common-frontend-builder',
                    'Content Team',
                    'Corporate Marketing',
                    'Demand Generation',
                    'Desk Q2 2021',
                    'dev-env',
                  ],
                })
              "
              >AutomationsCardProjectListModal</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { TTextField } from '@teamwork/ui-kit';
import projectsAxios from '@teamwork/fetcher';
import { defineComponent, inject, provide, watch } from 'vue-demi';
import { $t } from '@/i18n';
import { useStorage } from '@vueuse/core';
import useVuelidate from '@vuelidate/core';
import { required, numeric, or, sameAs } from '@vuelidate/validators';
import { endOfMonth, formatISO, startOfMonth } from 'date-fns';

export default defineComponent({
  components: {
    TTextField,
  },
  setup() {
    const { modalManager, routeManager, logger } = inject('appFacade');

    const projectId = useStorage('projectId', 5);
    const projectType = useStorage('projectType', 'normal');
    const budgetId = useStorage('budgetId', 1);
    const featuredTemplates = useStorage('featuredTemplates', '');
    const defaultTrigger = useStorage('defaultTrigger', '');
    const automationId = useStorage('automationId', '');
    const boardColumnId = useStorage('boardColumnId', 0);
    const workflowId = useStorage('workflowId', 0);
    const workflowStageId = useStorage('workflowStageId', 0);
    const categoryToShow = useStorage('categoryToShow', '');
    const initialView = useStorage('initialView', 'templates');
    provide('devData', {
      projectId,
      projectType,
      budgetId,
      featuredTemplates,
      automationId,
      boardColumnId,
      workflowId,
      workflowStageId,
      categoryToShow,
      initialView,
    });

    watch(projectId, async (newProjectId) => {
      const { data } = await projectsAxios.get(`/projects/api/v3/projects/${newProjectId}.json`);
      projectType.value = data.project.type;
    });

    const rules = {
      projectId: {
        required,
        numeric,
      },
      projectType: { required },
      budgetId: { numeric },
      featuredTemplates: {},
      defaultTrigger: {},
      automationId: {},
      boardColumnId: { numeric },
      workflowId: { numeric },
      workflowStageId: { numeric },
      categoryToShow: {},
      initialView: {
        shouldBeChecked: or(
          sameAs('templates'),
          sameAs('manage'),
          sameAs('builder'),
          sameAs('usage'),
        ),
      },
    };
    const v$ = useVuelidate(
      rules,
      {
        projectId,
        budgetId,
        featuredTemplates,
        defaultTrigger,
        boardColumnId,
        workflowId,
        workflowStageId,
        categoryToShow,
        initialView,
      },
      { $autoDirty: true },
    );

    const minDate = formatISO(startOfMonth(new Date()));
    const maxDate = formatISO(endOfMonth(new Date()));

    const openConfirmDialog = async () => {
      const confirmed = await modalManager.openDialog({
        heading: $t('Are you sure you want to go to the People page?'),
        message: $t('This will redirect you to the people page'),
        type: 'warning',
        confirmButtonText: $t('Yes please!'),
      });
      console.log('confirmed:', confirmed);

      if (confirmed) {
        routeManager.push(`/people`);
      } else {
        logger.logError('cancelled from the dialog');
      }
    };

    const onCreateBudgetSuccessCallback = ({ budget }) => {
      if (budget) {
        budgetId.value = budget.id;
      }
    };

    return {
      baseUrl: process.env?.VUE_APP_PROXY_TARGET ?? '',
      openConfirmDialog,
      onCreateBudgetSuccessCallback,
      openModal: modalManager.openModal,
      projectId,
      projectType,
      budgetId,
      featuredTemplates,
      defaultTrigger,
      automationId,
      boardColumnId,
      workflowId,
      workflowStageId,
      categoryToShow,
      initialView,
      v$,
      minDate,
      maxDate,
    };
  },
});
</script>
